import { useId } from "react"
import clsx from "clsx"
import { Field, useField } from "formik"
import S from "./rating-field.module.scss"
import Star from "../svgs/star.svg"

const RatingField = (props: { label: string; name: string }) => {
  const [, meta] = useField(props)
  const id = useId()

  const renderStars = (field: any) => {
    const stars = []
    const max = 5

    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= max; i++) {
      stars.push(
        <button
          className={clsx(S.button, { [S.selected]: i <= field.value })}
          key={i}
          onClick={() =>
            field.onChange({ target: { name: props.name, value: i } })
          }
          aria-label={`${i} ${i === 1 ? "star" : "stars"}`}
          aria-pressed={i <= field.value}
          type="button"
        >
          <Star />
        </button>,
      )
    }

    return stars
  }

  return (
    <div>
      {props.label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          id={id}
          className={clsx({ "text-danger": meta.error && meta.touched })}
        >
          {props.label}
        </label>
      )}
      <div
        className={clsx({
          "is-invalid": meta.error && meta.touched,
        })}
      >
        <Field id={id} name={props.name}>
          {({ field }: { field: any }) => renderStars(field)}
        </Field>
      </div>

      {meta.touched && meta.error && (
        <span className="invalid-feedback d-inline-block">{meta.error}</span>
      )}
    </div>
  )
}

export default RatingField
